import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  Renderer2,
  ElementRef,
  HostListener,
} from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormArray,
  FormControl,
  ValidatorFn,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import { GeneralService } from '../../../../../services/general/general.service';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['../../../../../../shared-styles/settings.scss'],
})
export class IndexComponent implements OnInit, OnDestroy {
  public form: FormGroup;
  public languages: any = [];
  public other_activities: any = [];
  public lessons: any = [];
  public subjects: any = [];
  public languageLevels: any = [];
  public subjectLevels: any = [];
  public loading: any = false;
  public sending: any = false;
  public subscriptions: any = [];
  public lessonsLevels: any = [];
  public AllLessonsLevels: any = [];
  public lessonLevelStatus: any = [];

  constructor(
    private formBuilder: FormBuilder,
    public general: GeneralService
  ) {
    this.form = this.formBuilder.group({
      subjects: this.formBuilder.array([]),
      languages: this.formBuilder.array([]),
      other_activities: this.formBuilder.array([]),
    });
  }

  async ngOnInit() {
    try {
      document.addEventListener('set-lang', this);
      this.intializeSubscriptions();
      await this.loadData();
    } catch (error: any) {
      await this.general.showDanger(error.message);
    }
  }

  async loadData() {
    try {
      this.general.setLoading(true);
      this.subjectsFormArray.clear();
      this.subjectsLangFormArray.clear();
      this.subjectsOtherActivityFormArray.clear();
      const requests = [
        this.general.httpGet('study-lessons'),
        this.general.httpGet('countries'),
        this.general.httpGet('lessons-levels'),
        this.general.httpGet('teacher-profile-lessons-data'),
      ];

      const response: any = await this.general.forkJoin(requests);
      this.lessons = response[0].data; 
      
      this.languages = response[0].data.filter(
        (subject: any) => subject.type === 'language'
      );
      this.subjects = response[0].data.filter(
        (subject: any) => subject.type === 'subject'
      );
      this.other_activities = response[0].data.filter(
        (subject: any) => subject.type === 'other'
      );
      this.subjectLevels = response[2].data.filter(
        (subject: any) => subject.type === 'subject'
      );
      this.languageLevels = response[2].data.filter(
        (subject: any) => subject.type === 'language'
      );

      this.lessonsLevels = [];
      this.AllLessonsLevels = [];

      response[3].data.lessons_and_levels.forEach((lessonsLevel: any) => {       

        let element = this.lessonsLevels.find((l: any) => {
          if (lessonsLevel.name) {
            return (
              lessonsLevel.lesson_id === l.lesson_id &&
              lessonsLevel.name === l.name && lessonsLevel.price_hour_single===l.price_hour_single
            );
          } else {
            return (lessonsLevel.lesson_id === l.lesson_id);
          }
        });   

        let element2 = this.AllLessonsLevels.find((l: any) => {
          if (lessonsLevel.name) {
            return (
              lessonsLevel.lesson_id === l.lesson_id &&
              lessonsLevel.name === l.name && lessonsLevel.price_hour_single===l.price_hour_single
            );
          } else {
            return lessonsLevel.lesson_id === l.lesson_id;
          }
        });

        if (element) {
          if (lessonsLevel.selected) {
            element.levels.push({
              id: lessonsLevel.level_id,
              state: lessonsLevel.status,
              selected: lessonsLevel.selected,
              price_hour_single: lessonsLevel.price_hour_single,
              
            });
          }
        } else {
          if (lessonsLevel.selected) {
            this.lessonsLevels.push({
              lesson_id: lessonsLevel.lesson_id,
              name: lessonsLevel.name,
              levels: [
                {
                  id: lessonsLevel.level_id,
                  state: lessonsLevel.status,
                  selected: lessonsLevel.selected,
                },
              ],
              price_hour_single: lessonsLevel.price_hour_single,
             
              
            });
          }
        }
       

        if (element2) {
          element2.levels.push({
            id: lessonsLevel.level_id,
            state: lessonsLevel.status,
            selected: lessonsLevel.selected,
            price_hour_single: lessonsLevel.price_hour_single,
          });
        } else {
          this.AllLessonsLevels.push({
            lesson_id: lessonsLevel.lesson_id,
            levels: [
              {
                id: lessonsLevel.level_id,
                state: lessonsLevel.status,
                selected: lessonsLevel.selected,
              },
            ],
            price_hour_single: lessonsLevel.price_hour_single,
          });
        
        }
      });

   
      // New Change
      this.lessonsLevels.forEach((element: any) => {

        let levels: any = [];
        let levelsStatus: any = [];

        element.levels.forEach((level: any) => {

          if (level.selected && level.id) {
            levels.push(level.id);
          }

        levelsStatus[level.id] = level.state;
          
        });

        let lesson = this.lessons.find(
          (lesson: any) => lesson.id == element.lesson_id
        );

        if(lesson){
          this.lessonLevelStatus[lesson.id] = levelsStatus;
        }

        if (lesson) {

          if (lesson.type === 'subject') {
            this.subjectsFormArray.push(
              this.formBuilder.group(
                {
                  study_lesson: [lesson],
                  lesson_level_id: [levels],
                  name: [element.name ? element.name : ''],
                  price_hour_single: [element.price_hour_single ? element.price_hour_single : ''],
                },
                { validators: [this.validateFormSubjects] }
              )
            );

          } else if (lesson.type === 'language') {

            this.subjectsLangFormArray.push(
              this.formBuilder.group(
                {
                  study_lesson: [lesson],
                  lesson_level_id: [levels],
                  name: [element.name ? element.name : ''],
                  price_hour_single: [element.price_hour_single ? element.price_hour_single : ''],
                },
                { validators: [this.validateFormSubjects] }
              )
            );

          }else if (lesson.type === 'other_activities' || lesson.type === 'other') {

            this.subjectsOtherActivityFormArray.push(
              this.formBuilder.group(
                {
                  study_lesson: [lesson],
                  name: [element.name ? element.name : ''],
                  price_hour_single: [element.price_hour_single ? element.price_hour_single : ''],
                },
                { validators: [this.validateFormSubjects] }
              )
            );
          }

        } else {
       
          switch (element.lesson_id) {
            case -1:
              this.subjectsFormArray.push(
                this.formBuilder.group(
                  {
                    study_lesson: [''],
                    lesson_level_id: [levels],
                    name: [element.name],
                    price_hour_single: [element.price_hour_single ? element.price_hour_single : ''],
                  },
                  { validators: [this.validateFormSubjects] }
                )
              );
              break;
            case -2:
              this.subjectsLangFormArray.push(
                this.formBuilder.group(
                  {
                    study_lesson: [''],
                    lesson_level_id: [levels],
                    name: [element.name],
                    price_hour_single: [element.price_hour_single ? element.price_hour_single : ''],
                  },
                  { validators: [this.validateFormSubjects] }
                )
              );
              break;
            case -3:
              this.subjectsOtherActivityFormArray.push(
                this.formBuilder.group(
                  {
                    study_lesson: [''],
                    name: [element.name],
                    price_hour_single: [element.price_hour_single ? element.price_hour_single : ''],
                  },
                  { validators: [this.validateFormSubjects] }
                )
              );
              break;
          }
        }
      });

      // Check subjects
      if (!this.subjectsFormArray.value.length) {
        this.subjectsFormArray.push(
          this.formBuilder.group(
            {
              study_lesson: [''],
              lesson_level_id: [[]],
              name: [''],
              price_hour_single: [''],
            },
            { validators: [this.validateFormSubjects] }
          )
        );
      }

      if (!this.subjectsLangFormArray.value.length) {
        this.subjectsLangFormArray.push(
          this.formBuilder.group(
            {
              study_lesson: [''],
              lesson_level_id: [[]],
              name: [''],
              price_hour_single: [''],
            },
            { validators: [this.validateFormSubjects] }
          )
        );
      }

      if (!this.subjectsOtherActivityFormArray.value.length) {
        this.subjectsOtherActivityFormArray.push(
          this.formBuilder.group(
            {
              study_lesson: [''],
              name: [''],
              price_hour_single: [''],
            },
            { validators: [this.validateFormSubjects] }
          )
        );
      }

    } catch (error: any) {
      await this.general.showDanger(error.message);

    } finally {
      this.general.setLoading(false);
    }

  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription: any) => {
      subscription.unsubscribe();
    });
    document.removeEventListener('set-lang', this);
  }

  intializeSubscriptions() {
    this.subscriptions = [
      this.general.loading$.subscribe((res) => (this.loading = res)),
    ];
  }
  // Handle event Listener
  async handleEvent(event: any) {
    switch (event.type) {
      case 'set-lang':
        await this.loadData();
        break;
    }
  }

  async sendform() {
    try {
      let subjects: any = [];
      this.form.value.subjects.forEach((subject: any) => {

        if (subject.study_lesson.id || subject.lesson_level_id.length || subject.name || subject.price_hour_single) {
          if (subject.study_lesson.id) {
            subjects.push({
              lesson_level_id: subject.lesson_level_id
                ? subject.lesson_level_id
                : null,
              study_lesson: subject.study_lesson.id,
              name: subject.name ? subject.name : null,
              price_hour_single: subject.price_hour_single,
            });
          } else {
            subjects.push({
              lesson_level_id: subject.lesson_level_id
                ? subject.lesson_level_id
                : null,
              study_lesson: -1,
              name: subject.name ? subject.name : null,
              price_hour_single: subject.price_hour_single,
            });
          }
        }
      });

      this.form.value.languages.forEach((subject: any) => {

        if ( subject.study_lesson.id || subject.lesson_level_id.length || subject.name || subject.price_hour_single) {
          if (subject.study_lesson.id) {
            subjects.push({
              lesson_level_id: subject.lesson_level_id
                ? subject.lesson_level_id
                : null,
              study_lesson: subject.study_lesson.id,
              name: subject.name ? subject.name : null,
              price_hour_single: subject.price_hour_single,
            });
          } else {
            subjects.push({
              lesson_level_id: subject.lesson_level_id
                ? subject.lesson_level_id
                : null,
              study_lesson: -2,
              name: subject.name ? subject.name : null,
              price_hour_single: subject.price_hour_single,
            });
          }
        }
      });

      this.form.value.other_activities.forEach((subject: any) => {

        if ( subject.study_lesson.id || subject.name || subject.price_hour_single) {
          if (subject.study_lesson.id) {
            subjects.push({
              lesson_level_id: null,
              study_lesson: subject.study_lesson.id,
              name: subject.name ? subject.name : null,
              price_hour_single: subject.price_hour_single,
            });
          } else {
            subjects.push({
              lesson_level_id: null,
              study_lesson: -3,
              name: subject.name ? subject.name : null,
              price_hour_single: subject.price_hour_single,
            });
          }
        }
      });


      // this.form.value.other_activities.forEach((subject: any) => {
      //   //aqui falta

      //   if(subject.study_lesson.id || subject.name || subject.price_hour_single )
        
      //   if (subject.study_lesson.id || subject.name) {
      //     subjects.push({
      //       lesson_level_id: subject.lesson_level_id,
      //       study_lesson: -3,
      //       name: subject.name,
      //       price_hour_single: subject.price_hour_single,
      //     });
      //   }
      // });





      if (!subjects.length) {
        await this.general.showDanger('one-subject-is-required');
        return;
      }

      const body = {
        subjects,
      };

      this.sending = true;

      const response = await this.general.httpPost(
        'upd-teacher-profile-lessons-data',
        body
      );

      await this.general.showSuccess('data-saved-successfully');
    } catch (error) {
      await this.general.showErrorForm(error);
    } finally {
      this.sending = false;
    }
  }

  /**
   * =================== Form ===================
   */
  get validateFormSubjects() {
    return (formGroup: FormGroup) => {
      let res = null;

      if (formGroup.errors && !formGroup.errors.badOrder) {
        // return if another validator has already found an error on the matchingControl
        return;
      }
      const lessonControl = formGroup.controls['study_lesson'];
      const levelControl = formGroup.controls['lesson_level_id'];
      const nameControl = formGroup.controls['name'];
      const price_hour_singleControl = formGroup.controls['price_hour_single'];

      // No validate if all is blank
      if (lessonControl && levelControl && nameControl && price_hour_singleControl) {
        // Subjects and languages
        if (
          !lessonControl.value &&
          !nameControl.value &&
          !price_hour_singleControl.value &&
          !levelControl.value.length
        ) {
          lessonControl.setErrors(res);
          levelControl.setErrors(res);
          nameControl.setErrors(res);
          price_hour_singleControl.setErrors(res);
          return;
        }
      } else {
        // Other activities
        if (!nameControl.value || !price_hour_singleControl.value) {
          nameControl.setErrors(res);
          price_hour_singleControl.setErrors(res);
          return;
        }
      }

      // Validate if some input is filled
      if (lessonControl && levelControl && price_hour_singleControl) {
        // Subjects and languages
        if (
          !(
            (lessonControl.value || nameControl.value) &&
            levelControl.value.length || price_hour_singleControl.value
          )
        ) {
          res = { required: true };

          if (!lessonControl.value) {
            lessonControl.setErrors(res);
          }
          if (!levelControl.value.length) {
            levelControl.setErrors(res);
          }
          if (!nameControl.value) {
            nameControl.setErrors(res);
          }
          if (!price_hour_singleControl.value.length) {
            price_hour_singleControl.setErrors(res);
          }
        }
      } else {
        if (!nameControl.value) {
          res = { required: true };
          nameControl.setErrors(res);
          return;
        }
      }

      if (res) {
        return;
      }

      if (lessonControl) lessonControl.setErrors(res);
      if (levelControl) levelControl.setErrors(res);
      if (nameControl) nameControl.setErrors(res);
      if (price_hour_singleControl) price_hour_singleControl.setErrors(res);

    };
  }

  onChangeStudyLesson(event: any, subject: any) {
    subject.patchValue({
      lesson_level_id: [],
    });
  }

  get subjectsFormArray(): any {
    return this.form.get('subjects') as FormArray;
  }

  addSubject(): void {
    this.subjectsFormArray.push(
      this.formBuilder.group(
        {
          study_lesson: [''],
          lesson_level_id: [[]],
          name: [''],
          price_hour_single: [''],
        },
        { validators: [this.validateFormSubjects] }
      )
    );
  }

  removeSubject(index: any): void {
    this.subjectsFormArray.removeAt(index);

    if (!this.subjectsFormArray.value.length) {
      this.addSubject();
    }
  }

  get subjectsLangFormArray(): any {
    return this.form.get('languages') as FormArray;
  }

  addSubjectLang(): void {    
    this.subjectsLangFormArray.push(
      this.formBuilder.group(
        {
          study_lesson: [''],
          lesson_level_id: [[]],
          name: [''],
          price_hour_single: [''],
        },
        { validators: [this.validateFormSubjects] }
      )
    );
    
  }

  removeSubjectLang(index: any): void {
    this.subjectsLangFormArray.removeAt(index);

    if (!this.subjectsLangFormArray.value.length) {
      this.addSubjectLang();
    }
  }

  get subjectsOtherActivityFormArray(): any {
    return this.form.get('other_activities') as FormArray;
  }

  addSubjectOtherActivity(): void {
    this.subjectsOtherActivityFormArray.push(
      this.formBuilder.group(
        {
          study_lesson: [''],
          name: [''],
          price_hour_single: [''],
        },
        { validators: [this.validateFormSubjects] }
      )
    );
  }

  removeSubjectOtherActivity(index: any): void {
    this.subjectsOtherActivityFormArray.removeAt(index);

    if (!this.subjectsOtherActivityFormArray.value.length) {
      this.addSubjectOtherActivity();
    }
  }

  get validateform() {
    return this.form.valid;
  }
}
